import { Link } from "react-router-dom"

export default function ErrorPage() {
    return (<div className="page-container text-page">
        <div className="inner">
            <div className="text-page-content">
                <h1>Sorry</h1>
                <h3>We ran into an error!</h3>

                <Link to="/" className="btn">Home</Link>
            </div>
        </div>
    </div>
    )
}